import { render } from "./CustomUserAccess.vue?vue&type=template&id=e1564f30"
import script from "./CustomUserAccess.vue?vue&type=script&lang=js"
export * from "./CustomUserAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__